import React, { useState } from "react";
import { CustomButton, CustomDialog, CustomIconButton, icon, IconComponent } from "../../../../../../common/components";
import styles from "./CriteriaRow.module.css";
import { translate } from "../../../../../../common/providers";
import { CRITERIA_TYPES } from "../../constants";
import CriteriaCreation from "../criteria-creation/CriteriaCreation";
import { useApi } from "../../../../../../common/hooks";
import { FormStudioService } from "../../../../../../api";
import { translateEnumTypes } from "../../utils";
import AgentSidePanel from "../agent-panel/AgentSidePanel";

export default function CriteriaRow({ criteria, onDelete = null, onRefresh }) {
	const { id, name, type, pages, agentId, agentTitle } = criteria || {};
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [dialogType, setDialogType] = useState("");
	const [openAgentSidePanel, setOpenAgentSidePanel] = useState(false);
	const { call: duplicateCriteria } = useApi(FormStudioService.duplicateCriteria);
	const { call: updateCriteria } = useApi(FormStudioService.updateCriteria);
	const { call: getCriteria } = useApi(FormStudioService.getCriteria);

	const handleOpenDeleteDialog = () => {
		setOpenDeleteDialog((prev) => !prev);
	};
	const handleChangeAgent = (newAgent) => {
		getCriteria({ fieldId: criteria.id })
			.then((data) => {
				const payload = { ...data, agentId: newAgent?.id || null };
				updateCriteria({ fieldId: id }, payload)
					.then(() => {
						if (onRefresh && typeof onRefresh === "function") {
							onRefresh();
						}
						setOpenAgentSidePanel(false);
					})
					.catch(console.error);
			})
			.catch(console.error);
	};
	const handleDelete = () => {
		if (onDelete && typeof onDelete === "function") {
			onDelete(criteria);
			setOpenDeleteDialog(false);
		}
	};
	const handleOpenEdit = () => {
		setDialogType("modification");
	};
	const handleOpenDuplicate = () => {
		duplicateCriteria({ fieldId: criteria.id })
			.then(() => {
				if (onRefresh && typeof onRefresh === "function") {
					onRefresh();
				}
			})
			.catch(console.error);
	};
	const handleOpenDialogAgentSelection = () => {
		setOpenAgentSidePanel((prev) => !prev);
	};
	return (
		<div key={id} className={styles.row}>
			<div>
				<span>{name}</span>
			</div>
			<div>
				<span className={styles.criteriaType}>
					<IconComponent icon={icon[CRITERIA_TYPES[type].icon]} />
					<span>{translateEnumTypes(CRITERIA_TYPES[type].name)}</span>
				</span>
			</div>
			<div>
				<span className={styles.limitedText}>{pages.map((view) => view?.name).join(", ")}</span>
			</div>
			<div>
				<CustomButton variant={(agentId && "outlined") || "contained"} onClick={handleOpenDialogAgentSelection}>
					{(agentId && agentTitle) || translate("dsi.form-studio.criteria.select-agent.button")}
				</CustomButton>
			</div>
			<div className={styles.actions}>
				<CustomIconButton
					icon={icon.faPenToSquare}
					size="sm"
					tooltip={translate("common:btn.edit")}
					variant="outlined"
					onClick={handleOpenEdit}
				/>
				<CustomIconButton
					icon={icon.faCopy}
					size="sm"
					tooltip={translate("dsi.form-studio.row-action.duplicate")}
					variant="outlined"
					onClick={handleOpenDuplicate}
				/>
				<CustomIconButton
					icon={icon.faTrash}
					size="sm"
					tooltip={translate("common:btn.delete")}
					variant="outlined"
					onClick={handleOpenDeleteDialog}
				/>
			</div>
			<CustomDialog
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={openDeleteDialog}
				submitColor="destructive"
				subTitle={translate("dsi.form-studio.criteria.deletion.confirmation-text", {
					count: criteria?.views?.length,
				})}
				title={translate("common:delete-confirmation-popup.title")}
				onClose={handleOpenDeleteDialog}
				onSubmit={handleDelete}
			/>
			{dialogType && (
				<CriteriaCreation
					criteria={criteria}
					dialogType={dialogType}
					open={!!dialogType}
					onClose={() => setDialogType("")}
					onRefresh={onRefresh}
				/>
			)}
			<AgentSidePanel
				agent={{ agentId: criteria?.agentId, agentTitle: criteria?.agentTitle }}
				open={openAgentSidePanel}
				onClose={handleOpenDialogAgentSelection}
				onSubmit={handleChangeAgent}
			/>
		</div>
	);
}
